import { IncentiveForm } from './incentive-form'
import { useEffect, useRef } from 'react'
import type { IncentiveItemFormType } from '@/schema/incentive.schema'

type IncentiveModalProps = {
  onCloseModal: () => void
  incentiveByModal?: IncentiveItemFormType & { id?: string }
}

export default function IncentiveModal({
  incentiveByModal,
  onCloseModal,
}: IncentiveModalProps) {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        !target.closest('.dropdown-content') &&
        !target.closest('[data-radix-popper-content-wrapper]') &&
        !target.closest('[role="dialog"]') &&
        !target.closest('[role="listbox"]')
      ) {
        onCloseModal()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="absolute h-screen" data-testid="create-incentive-item-form">
      <div className="fixed top-0 left-0 z-30 w-full h-screen bg-ui-100 opacity-60"></div>
      <div className="flex justify-center fixed top-10 left-0 z-40 w-full h-full">
        <div
          className="flex flex-col w-3/6 absolute p-6 z-50 bg-white rounded-md shadow-md overflow-y-scroll h-5/6"
          ref={ref}
        >
          <IncentiveForm
            incentiveByModal={incentiveByModal}
            onCloseModal={onCloseModal}
          />
        </div>
      </div>
    </div>
  )
}
